/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Switch du portail actif (enforcé côté serveur à chaque requête). Le portail doit être accessible au compte — briques + garde de gouvernance pour le Portail Plateforme (membre actif de la PM principale de l'orga active).
 * 
 * @export
 * @interface SwitchPortailCommand
 */
export interface SwitchPortailCommand {
    /**
     * Nom du portail à activer (Codes.Portails)
     * @type {string}
     * @memberof SwitchPortailCommand
     */
    portail: string;
}

/**
 * Check if a given object implements the SwitchPortailCommand interface.
 */
export function instanceOfSwitchPortailCommand(value: object): value is SwitchPortailCommand {
    if (!('portail' in value) || value['portail'] === undefined) return false;
    return true;
}

export function SwitchPortailCommandFromJSON(json: any): SwitchPortailCommand {
    return SwitchPortailCommandFromJSONTyped(json, false);
}

export function SwitchPortailCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchPortailCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'portail': json['portail'],
    };
}

export function SwitchPortailCommandToJSON(json: any): SwitchPortailCommand {
    return SwitchPortailCommandToJSONTyped(json, false);
}

export function SwitchPortailCommandToJSONTyped(value?: SwitchPortailCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portail': value['portail'],
    };
}

